import React, { useEffect } from 'react';

import styled from 'styled-components';

import { Button, Toast, Tabs } from 'react-bootstrap';

import { faTimes, faCheck, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/*
 * Peças visuais compartilhadas pelas telas de gestão (fornecedores, associações,
 * microrregiões e custos): cabeçalho, barra de busca, tabela, paginação e painel lateral.
 */

export const Container = styled.div`
    margin: 20px auto;
    max-width: 90vw;
    max-heigth: 80vh;
`;
export const CenteredTD = styled.td`
    text-align: center;
`;
/* Listagem */

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;

    h4 {
        margin-bottom: 2px;
        color: var(--vft-ink);
    }

    small {
        color: var(--vft-muted);
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    gap: 8px;

    .btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border-radius: 6px;
        font-size: 14px;
    }
`;

export const PrimaryButton = styled(Button)`
    background-color: var(--vft-ink);
    border-color: var(--vft-ink);

    &:hover, &:focus, &:active {
        background-color: var(--vft-ink-hover) !important;
        border-color: var(--vft-ink-hover) !important;
    }
`;

export const Panel = styled.div`
    background: #fff;
    border: 1px solid var(--vft-border);
    border-radius: 10px;
    padding: 8px 16px 12px;
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 0 12px;
`;

export const ToolbarFilters = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
`;

export const SearchBox = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1 320px;
    max-width: 420px;
    color: var(--vft-muted);

    input {
        flex: 1;
        min-width: 0;
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        color: var(--vft-ink);
        padding: 6px 0;
    }

    input::placeholder {
        color: var(--vft-faint);
    }

    &.compact {
        flex: 0 0 160px;
        border: 1px solid var(--vft-border);
        border-radius: 6px;
        padding: 0 10px;
    }
`;

export const ClearButton = styled.button`
    border: none;
    background: transparent;
    color: var(--vft-faint);
    padding: 0 2px;
    cursor: pointer;

    &:hover {
        color: var(--vft-ink);
    }
`;

export const FilterSelect = styled.select`
    height: 34px;
    max-width: 220px;
    border: 1px solid var(--vft-border);
    border-radius: 6px;
    background-color: #fff;
    padding: 0 8px;
    font-size: 14px;
    color: var(--vft-ink);
`;

export const GhostButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    font-size: 14px;
    color: var(--vft-ink);
    cursor: pointer;

    &:hover, &[aria-expanded="true"] {
        background-color: var(--vft-hover);
    }
`;

export const TableScroll = styled.div`
    overflow-x: auto;
`;

export const ListTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 14px;
    color: var(--vft-ink);

    th {
        background-color: var(--vft-subtle);
        color: var(--vft-muted);
        font-weight: 500;
        font-size: 13px;
        padding: 12px 14px;
        white-space: nowrap;
        border: none;
    }

    th:first-child {
        border-radius: 8px 0 0 8px;
    }

    th:last-child {
        border-radius: 0 8px 8px 0;
    }

    td {
        padding: 12px 14px;
        vertical-align: middle;
        border: none;
    }

    tbody tr:first-child td {
        padding-top: 16px;
    }

    tbody tr:hover td {
        background-color: var(--vft-subtle);
    }

    tbody tr:hover td:first-child {
        border-radius: 8px 0 0 8px;
    }

    tbody tr:hover td:last-child {
        border-radius: 0 8px 8px 0;
    }

    .number {
        text-align: right;
        white-space: nowrap;
    }

    .actions {
        width: 48px;
        text-align: right;
    }

    .name {
        font-weight: 500;
    }

    .muted {
        color: var(--vft-faint);
    }
`;

export const Chip = styled.span`
    display: inline-block;
    padding: 4px 10px;
    border-radius: 6px;
    background-color: var(--vft-subtle);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .02em;
    white-space: nowrap;
`;

export const StatusDot = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: var(--vft-faint);
    }

    &.success::before {
        background-color: var(--vft-success);
    }

    &.danger::before {
        background-color: var(--vft-accent);
    }

    &.muted::before {
        background-color: var(--vft-border-strong);
    }
`;

export const RowMenuToggle = styled.button`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--vft-ink);
    cursor: pointer;

    &:hover, &[aria-expanded="true"] {
        background-color: var(--vft-hover);
    }
`;

/* Painel lateral de edição */

export const Drawer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030; /* abaixo dos modais do bootstrap (1040+) */
`;

export const DrawerBackdrop = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(17, 24, 39, .35);
    animation: drawerFade .2s ease;

    @keyframes drawerFade {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

export const DrawerPanel = styled.aside`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(680px, 100vw);
    display: flex;
    flex-direction: column;
    background: #fff;
    box-shadow: -12px 0 40px rgba(17, 24, 39, .15);
    animation: drawerSlide .25s ease;

    @keyframes drawerSlide {
        from { transform: translateX(40px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
    }
`;

export const DrawerHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 12px;

    h5 {
        margin: 0;
        font-weight: 600;
        color: var(--vft-ink);
    }
`;

export const IconButton = styled.button`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--vft-ink);
    cursor: pointer;

    &:hover {
        background-color: var(--vft-hover);
    }
`;

export const DrawerBody = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 24px;
    color: var(--vft-ink);
    font-size: 14px;

    .form-group label {
        font-size: 13px;
        color: var(--vft-muted);
        margin-bottom: 4px;
    }

    .form-control, .custom-select {
        border-radius: 6px;
        border-color: var(--vft-border);
        font-size: 14px;
    }
`;

export const StatusActions = styled.div`
    display: flex;
    gap: 8px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--vft-border);
    margin-bottom: 8px;

    .btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        border-radius: 6px;
    }
`;

export const DrawerTabs = styled(Tabs)`
    border-bottom: 1px solid var(--vft-border);
    margin-bottom: 16px;

    .nav-link {
        border: none;
        border-bottom: 2px solid transparent;
        color: var(--vft-muted);
        padding: 10px 2px;
        margin-right: 20px;
    }

    .nav-link:hover {
        color: var(--vft-ink);
    }

    .nav-link.active {
        color: var(--vft-ink);
        font-weight: 600;
        border-bottom-color: var(--vft-ink);
    }
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: 600;
`;

export const FormActions = styled.div`
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin: 8px -24px 0;
    padding: 14px 24px;
    background: #fff;
    border-top: 1px solid var(--vft-border);

    .btn {
        border-radius: 6px;
    }
`;

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px 0;
    color: var(--vft-muted);
    font-size: 14px;
`;

export const PageButton = styled.button`
    width: 32px;
    height: 32px;
    margin-left: 4px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--vft-ink);
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: var(--vft-hover);
    }

    &:disabled {
        color: var(--vft-border-strong);
        cursor: default;
    }
`;

export const StyledToast = styled(Toast)`
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 10000;

    & .toast-header {
        background-color: black;
        color: #fff;
    }

    & .toast-header strong {
        margin: 3px 4px;
    }
`;

export const StyledTR = styled.tr`
    &.clickable {
        cursor: pointer;
    }

    &.clickable:focus {
        outline: none;
    }

    &.clickable:focus-visible td {
        box-shadow: inset 0 0 0 2px rgba(47, 91, 234, .25);
    }

    &.selected td, &.selected:hover td {
        background-color: var(--vft-hover);
    }

    &.inactive td, &.inactive:hover td {
        color: var(--vft-faint);
    }
`;


/* Componentes */

// Painel lateral (drawer). Fecha com ESC, exceto quando há um modal do bootstrap aberto por cima.
export function SideDrawer({ title, onClose, children }) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !document.body.classList.contains('modal-open')) onClose();
        }

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return <Drawer>
        <DrawerBackdrop onClick={onClose} />
        <DrawerPanel role="dialog" aria-modal="true" aria-label={title}>
            <DrawerHeader>
                <h5>{title}</h5>
                <IconButton onClick={onClose} aria-label="Fechar"><FontAwesomeIcon icon={faTimes} /></IconButton>
            </DrawerHeader>
            <DrawerBody>
                {children}
            </DrawerBody>
        </DrawerPanel>
    </Drawer>;
}

export function Pager({ currentPage, paginatorData, onChangePage }) {
    const pages = paginatorData ? paginatorData.pages : 0;

    return <Footer>
        <span>{pages ? `Página ${currentPage} de ${pages}` : ''}</span>
        <div>
            <PageButton disabled={!paginatorData || !paginatorData.hasPrevious} onClick={() => onChangePage(currentPage - 1)} aria-label="Página anterior">
                <FontAwesomeIcon icon={faArrowLeft} />
            </PageButton>
            <PageButton disabled={!paginatorData || !paginatorData.hasNext} onClick={() => onChangePage(currentPage + 1)} aria-label="Próxima página">
                <FontAwesomeIcon icon={faArrowRight} />
            </PageButton>
        </div>
    </Footer>;
}

export function SuccessToast({ show, message, onClose }) {
    return <StyledToast onClose={onClose} show={show} delay={3000} autohide>
        <Toast.Header>
            <FontAwesomeIcon icon={faCheck} />
            <strong className="mr-auto">Sucesso</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
    </StyledToast>;
}

// Busca com debounce: aplica 1s depois da última tecla, ou na hora com Enter.
let searchTimer = null;
export function SearchField({ value, onChange, onSearch, active, placeholder, icon }) {
    const handleKeyUp = (e) => {
        clearTimeout(searchTimer);

        const current = e.target.value;
        if (e.key === 'Enter') onSearch(current);
        else searchTimer = setTimeout(() => onSearch(current), 1000);
    }

    const clear = () => {
        clearTimeout(searchTimer);
        onChange('');
        onSearch('');
    }

    useEffect(() => () => clearTimeout(searchTimer), []);

    return <SearchBox>
        {icon && <FontAwesomeIcon icon={icon} />}
        <input placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} onKeyUp={handleKeyUp} />
        {active && <ClearButton onClick={clear} title="Limpar"><FontAwesomeIcon icon={faTimes} /></ClearButton>}
    </SearchBox>;
}

